import { DESCRIPTION_MAX_LENGTH, DESCRIPTION_MIN_LENGTH, TITLE_MAX_LENGTH } from '@/constants/Common'
import {
  EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
  EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
  EVENT_ANNOUNCEMENT_TITLE_MAX,
  EVENT_DESCRIPTION_REQUIRED,
  EVENT_NAME_REQUIRED,
  REGISTRATION_URL_REQUIRED,
} from '@/constants/MessageConstants'
import { stripHtml } from 'string-strip-html'
import * as Yup from 'yup'
import { LocationValidationSchema } from './CommonValidationSchema'

const editEventValidationSchema = Yup.object().shape({
  leagueName: Yup.string().required(EVENT_NAME_REQUIRED).max(TITLE_MAX_LENGTH, EVENT_ANNOUNCEMENT_TITLE_MAX),
  address: LocationValidationSchema,
  registrationUrl: Yup.string()
    .required(REGISTRATION_URL_REQUIRED)
    .test(
      'no-utrsports-url',
      'The provided URL can not be used for registration at this time',
      (value) => !value || !value.includes('app.utrsports.net')
    ),
  longDescription: Yup.string()
    .required(EVENT_DESCRIPTION_REQUIRED)
    .test(
      'minlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
      (desc) => stripHtml(desc).result.length >= DESCRIPTION_MIN_LENGTH
    )
    .test(
      'maxlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
      (desc) => stripHtml(desc).result.length <= DESCRIPTION_MAX_LENGTH
    ),
})

export default editEventValidationSchema
